<template>
    <div class="shopping-car-block">
        <el-drawer :visible.sync="this.$store.state.shoppingCarDrawer" :direction="direction" :with-header="false" size="70%" :before-close="close">
            <div class="content d-flex flex-column p-3 mb-2 justify-content-between h-100">
                <div class="info-block mb-2 pb-1" v-for="a in 10" :key="a">
                    <div class="column">
                        <img src="https://fakeimg.pl/500x500" alt="">
                        <div class="shpping-car-description-block">
                            <span class="title"> 德國品牌德國品牌 邁特輪胎本月完工特價歡迎詢問 (花紋類似馬牌CSC5)</span>
                            <span class="price"> $2999</span>
                        </div>
                        <div class="close-icon" @click="close">
                            <i class="el-icon-close"></i>
                        </div>
                    </div>
                    <div class="amount">
                        <span class="number">數量</span>
                        <el-input-number v-model="num" :min="1"></el-input-number>
                    </div>
                </div>
                <div class="border-top py-3">
                    <div class="action-block d-flex ">
                        <el-button class="btn w-100" type="info">加入購物車</el-button>
                        <el-button class="btn w-100" type="danger" @click="gotToCar">直接購買</el-button>
                    </div>
                </div>

            </div>
        </el-drawer>
    </div>
</template>

<script>

    export default {
        mixins: [],
        name: 'shoppingAction',
        data() {
            return {
                direction: 'btt',
                num:1,

            }
        },
        mounted() {
            console.log(this.$store.state.shoppingCarDrawer);
        },
        methods: {
            close(){
                this.$store.commit('setShoppingCarDrawer',false)
            },
            gotToCar(){
                this.$store.commit('setShoppingCarDrawer',false)
                this.$router.push({name: 'StoreCar'})
            }
        },
    }
</script>


<style>



</style>
